import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { DivElement } from './styles';
import { TableControls } from '../../../../BaseEditor';
import { fieldsPropType } from './PropTypes';

function BodyComponent({
  row, fields, rowNumber, onChange, active, onClick,
}) {
  const cr = (rowNumber * 1 + 2);
  const globalProps = {
    onClick: (e) => onClick(e, rowNumber),
  };
  const globalStyle = active ? {
    background: active ? 'linear-gradient(0deg,rgba(255,255,255,0.7),rgba(255,255,255,0.7)),#008F21' : 'initial',
  } : {};
  return (
    <>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / datefrom`,
        }}
        {...globalProps}
      >
        <TableControls.DateInput
          value={row.datefrom}
          onChange={(e, v) => onChange(e, rowNumber, { datefrom: v })}
          readOnly={fields.datefrom.read_only}
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / dateto`,
        }}
        {...globalProps}
      >
        <TableControls.DateInput
          value={row.dateto}
          onChange={(e, v) => onChange(e, rowNumber, { dateto: v })}
          readOnly={fields.dateto.read_only}
        />
      </DivElement>
      <DivElement
        style={{
          ...globalStyle,
          gridArea: `${cr} / rate`,
        }}
        {...globalProps}
      >
        <TableControls.NumerInput
          value={Number(row.rate)}
          onChange={(e, v) => onChange(e, rowNumber, { rate: v.toFixed(2) })}
          readOnly={fields.rate.read_only}
          precision={2}
        />
      </DivElement>
    </>
  );
}

BodyComponent.propTypes = {
  row: PropTypes.shape({
    datefrom: PropTypes.string,
    dateto: PropTypes.string,
    rate: PropTypes.number,
  }),
  fields: fieldsPropType,
  rowNumber: PropTypes.number,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

BodyComponent.defaultProps = {
  row: {
    datefrom: '',
    dateto: '',
    ratio: 0,
  },
  fields: {
    datefrom: {},
    dateto: {},
    rate: {},
  },
  rowNumber: 0,
  onChange: () => null,
  active: false,
  onClick: () => null,
};

export default memo(BodyComponent);
